export default __webpack_public_path__ + "static/media/anas.d6fb5e97.png";